import styled from 'styled-components';
import { WindowSizePXEnum } from '../../../../interface/Basic/window';
import { BoxIsolatedContent, IconContainer } from '../../../../components/ui/Content';
import { Body1, H2 } from '../../../../components/Font';
import { LoaderContainer } from '../../../../ui/Loader/MiniLoader';

export const LoaderContainerShadow = styled(LoaderContainer)`
	position: absolute;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.1);
	z-index: 1;
	border-radius: 8px;
`;

export const RegFormTitle = styled(H2)`
	text-align: center;
	width: 243px;
	font-size: 22px;
	line-height: 28px;
	@media (max-width: ${WindowSizePXEnum.xs}) {
		width: 300px;
	}
`;

export const RegisterFooter = styled.div`
	width: 100%;
	padding: 0 24px;
	button {
		width: 100%;
	}
`;

export const LogInLink = styled.div`
	position: absolute;
	bottom: -50px;
	display: flex;
	gap: 8px;
	@media (max-width: ${WindowSizePXEnum.xs}) {
		bottom: 30px;
	}
`;

export const FormDateContainer = styled.div`
	width: 100%;
`;

export const FormPassportContainer = styled.div`
	width: 100%;
	display: flex;
	gap: 16px;
	margin-top: 16px;
`;

export const PersonalDataAgreementContainer = styled.div`
	display: flex;
	gap: 10px;
	width: 100%;
	margin: 24px 0;

	${IconContainer} {
		height: fit-content;
	}
`;

export const AgreementTextRow = styled.div`
	display: inline;
	text-align: start;

	${Body1} {
		user-select: none;
		display: inline;

		:not(:first-child) {
			margin-left: 5px;
		}
	}
`;

export const FormPassportField = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	align-items: start;

	.input-container {
		margin: 0;
	}

	input {
		margin: 0;
		padding-top: 6px !important;
		padding-right: 40px !important;
		height: 40px;
	}
`;

export const BoxIsolated = styled(BoxIsolatedContent)`
	max-height: unset;
`;
